module.exports = __webpack_public_path__ + "static/js/dataWorker.f326961e.chunk.worker.js"